exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counters{display:block;float:right;margin-bottom:5px}", ""]);

// exports
